// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2l-3";
export var dialog = "_2l-0";
export var divClassnameSwatch = "_2l-8";
export var flexSwatch = "_2l-4";
export var header = "_2l-1";
export var styleAttributeSwatch = "_2l-7";
export var swatch = "_2l-2";
export var textHeaderSwatch = "_2l-5";
export var webSwatch = "_2l-6";